module.exports = __webpack_public_path__ + "static/banner-four-shape5-531c4e5dfdda4b6135b8094690c7446e.png";